export default __webpack_public_path__ + "static/hero-fire-bg-mobile-c6c6b24d5e5e944926800b54276e7ea5.jpg";